import axios from "axios"

const CommandeService = {}

CommandeService.ajouter =(formData)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/commande/ajouter`, formData  )

}
export default CommandeService ;